/**
 * Shuffle Array
 * @param {function} fn
 * @param {integer} wait
 * @returns
 *
 * Knuth Fisher-Yates optimized shuffle
 */
export const arrayShuffle = (arr) => {

	for(let i = arr.length - 1; i > 0; i--) {

        const j = Math.floor(Math.random() * (i + 1));

        [arr[i], arr[j]] = [arr[j], arr[i]];
    }

	return arr;
}
